import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';

import { GTMService, eventService } from '@services';
import { useStore } from '@stores';
import {
  executeRiskAssessmentRecaptcha,
  rollbar,
  shouldShowIntroUI,
} from '@utils';

import { Module } from '../Module';

const validModules = new Set([
  'MODULE_REVIEW',
  'MODULE_RESULT_OPTIONS',
  'MODULE_INTRO',
]);

const Modules = observer(() => {
  const { formStore, partnerStore } = useStore();
  const { currentModule } = formStore;
  const {
    options: { introUI },
  } = partnerStore;

  useEffect(() => {
    const moduleName = currentModule?.name;
    const moduleTitle = currentModule?.title;

    if (!moduleName || !shouldShowIntroUI(moduleName, introUI)) {
      return;
    }

    if (moduleName === 'MODULE_RESULT_OPTIONS') {
      GTMService.getInstance().sendResultPageview(
        `${document.title} - Options`
      );
      GTMService.getInstance().sendVirtualPageview(
        `${document.title} - Options`
      );
    } else {
      GTMService.getInstance().sendVirtualPageview(
        `${document.title} - ${moduleTitle}`
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentModule?.name]);

  if (
    validModules.has(currentModule?.name ?? '') ||
    (currentModule?.subModules &&
      currentModule?.subModules.length > 0 &&
      currentModule?.subModules[0] !== '')
  ) {
    return <Module />;
  } else {
    return <Box>Module Not Found</Box>;
  }
});

export const CounselorForm = observer(() => {
  const { userStore } = useStore();

  const recaptchaExecuted = useRef(false);

  useEffect(() => {
    if (recaptchaExecuted.current) {
      return;
    }
    recaptchaExecuted.current = true;

    const handleReCaptchaVerify = async () => {
      try {
        const token = await executeRiskAssessmentRecaptcha();
        if (token) {
          await eventService.createRiskAssessment(token);
        }
      } catch (error) {
        rollbar.warning('reCAPTCHA assessment first attempt failed', { error });
        try {
          await new Promise((r) => setTimeout(r, 1000));
          const token = await executeRiskAssessmentRecaptcha();
          if (token) {
            await eventService.createRiskAssessment(token);
          }
        } catch (retryError) {
          rollbar.warning('reCAPTCHA assessment failed', { error: retryError });
        }
      }
    };

    handleReCaptchaVerify();
  }, []);

  useEffect(() => {
    userStore.fetchIP();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Modules />;
});
